var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup335(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_335",
    "data-name": "Group 335",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.563,
    height: 10.403,
    viewBox: "0 0 9.563 10.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 9.563,
    height: 10.403,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M64.521,289.968a.517.517,0,0,1-.314-.537c.009-.646.005-1.292,0-1.937,0-.1.027-.134.131-.133q2.49,0,4.98,0c.107,0,.131.038.13.136q0,.984,0,1.968a.485.485,0,0,1-.33.5Z",
    transform: "translate(-62.465 -279.565)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M274.3,126.981a.3.3,0,0,1-.262.146.619.619,0,0,0-.588.6c-.011.156-.093.249-.222.255s-.217-.073-.239-.232c0-.027-.01-.053-.013-.08a.618.618,0,0,0-.579-.543c-.156-.012-.234-.062-.268-.175a.221.221,0,0,1,.166-.28c.069-.014.142-.015.211-.032a.626.626,0,0,0,.47-.527c.006-.04.011-.08.017-.12a.225.225,0,0,1,.437-.038.479.479,0,0,1,.02.109.617.617,0,0,0,.577.59.318.318,0,0,1,.274.145Z",
    transform: "translate(-264.742 -122.385)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M274.3,240.733a.3.3,0,0,1-.236.135.628.628,0,0,0-.6.488,1.48,1.48,0,0,0-.018.15.238.238,0,0,1-.231.226.227.227,0,0,1-.225-.228.655.655,0,0,0-.419-.6.987.987,0,0,0-.228-.046.228.228,0,0,1,0-.455.728.728,0,0,0,.319-.087.663.663,0,0,0,.323-.544c.016-.158.093-.23.228-.228a.225.225,0,0,1,.229.245.638.638,0,0,0,.612.612.266.266,0,0,1,.24.145Z",
    transform: "translate(-264.739 -233.051)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M6.638,7.375H2.09c.021-.056.067-.069.1-.09.537-.323,1.074-.646,1.613-.965a.178.178,0,0,0,.1-.178q-.008-.294,0-.589a.182.182,0,0,0-.094-.173A6.485,6.485,0,0,1,2.292,4a3.306,3.306,0,0,1-.3-.459.122.122,0,0,0-.1-.078,1.88,1.88,0,0,1-1.391-1A3.868,3.868,0,0,1,.037.953C.019.8,0,.643,0,.488A.444.444,0,0,1,.483,0H8.242a.433.433,0,0,1,.467.453,4.065,4.065,0,0,1-.561,2.1,1.837,1.837,0,0,1-1.33.909.115.115,0,0,0-.094.065A5.054,5.054,0,0,1,5.347,5.055c-.149.117-.3.227-.46.334a.168.168,0,0,0-.081.16c0,.2,0,.393,0,.589a.17.17,0,0,0,.1.17q.822.487,1.64.98c.033.02.075.031.1.087m.329-5.7c0,.236,0,.473,0,.709,0,.026-.012.059.014.076s.056-.012.08-.028a1.046,1.046,0,0,0,.281-.275A2.7,2.7,0,0,0,7.766.976c.01-.065-.015-.092-.083-.091-.206,0-.413,0-.619,0-.077,0-.1.027-.1.1,0,.23,0,.459,0,.689m-5.222.009c0-.233,0-.466,0-.7,0-.075-.025-.1-.1-.1-.2,0-.4,0-.6,0C.958.881.932.915.946,1a3.246,3.246,0,0,0,.258.881,1.351,1.351,0,0,0,.454.56c.064.043.087.032.087-.047,0-.236,0-.473,0-.709",
    transform: "translate(-0.001 0.001)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M2.281,176.547a.234.234,0,0,1-.226.23.638.638,0,0,0-.642.638.229.229,0,0,1-.458,0,.639.639,0,0,0-.639-.641.229.229,0,0,1,0-.457.638.638,0,0,0,.643-.638.229.229,0,0,1,.458,0,.639.639,0,0,0,.639.641.233.233,0,0,1,.229.227",
    transform: "translate(-0.084 -170.694)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup335);
export default __webpack_public_path__ + "static/media/Group335.3c191478fa0e2b9fbaa42d09fda6659e.svg";
export { ForwardRef as ReactComponent };